<div class="modal-header">
    <h5 class="modal-title">Feedback</h5>
    <div>
        <a (click)="close()" title="Annuleren" class="btn btn-transparent mr-2">Sluiten</a>
    </div>
</div>
<div class="modal-body p-5">

    <ng-container *ngIf="loading">
        <div class="centerLoading">
            <i class="fa-solid fa-spinner"></i>
        </div>
    </ng-container>

    <ng-container *ngIf="!loading">
        <div class="header" id="row">
            <div class="col-8">
                <h2>{{portfolioData['item']['lessonTitle']}}</h2>
                <h3>{{portfolioData['item']['chapterTitle']}}</h3>
            </div>
            <div class="col-4">
                <p>{{portfolioData['item']['sectionTitle']}}</p>
                <p>Klas: {{portfolioData['item']['userClassroom']}}</p>
                <p>Voltooid op: {{formatDate(portfolioData['item']['createdAt'])}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <ng-container *ngFor="let data of portfolioData['blocks']">
                    <ng-container *ngIf="data.type == 'FILE'">
                        <div class="row portfolio-row">
                            <div class="col-6">
                                <h4>Wat heb ik gedaan?</h4>
                                <div *ngIf="data['items'] && data['items'].length > 0">
                                    <p class="mt-2 mb-1">{{data['items'][0].description}}</p>
                                    <div class="img_grid">
                                        <img *ngFor="let file of data['items']" [src]="file.content">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 feedback-container">
                                <div class="space-between">
                                    <h5>Feedback</h5>
                                    <button *ngIf="data.status == 'PERFECT'"
                                        class="btn btn-success"><span>Goed</span></button>
                                    <button *ngIf="data.status == 'GOOD'"
                                        class="btn btn-warning"><span>Voldoende</span></button>
                                    <button *ngIf="data.status == 'WRONG'"
                                        class="btn btn-danger"><span>Onvoldoende</span></button>
                                </div>
                                <hr>
                                <div class="teacherChat" *ngIf="data['feedbackItems'] && data['feedbackItems'].length > 0">
                                    <div *ngFor="let feedback of data['feedbackItems']">
                                        <h6>
                                            {{feedback.name}} 
                                            <small>{{formatDutchDate(feedback.createdAt)}}</small> 
                                            <span *ngIf="!feedback.readAt" class="unread-feedback">Nieuw</span>
                                        </h6>
                                        <p>{{feedback.message}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="data.type == 'REFLECTION'">
                        <div class="row portfolio-row">
                            <div class="col-6">
                                <h4 class="mb-2">Wat heb ik geleerd?</h4>
                                <div *ngIf="data['items'] && data['items'].length > 0">
                                    <div *ngFor="let reflection of data['items']" class="reflection">
                                        <b>{{ reflection.indexNumber }}. {{reflection.subtitle}}</b>
                                        <p>{{reflection.value}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6 feedback-container">
                                <div class="space-between">
                                    <h5>Feedback</h5>
                                    <button *ngIf="data.status == 'PERFECT'"
                                        class="btn btn-success"><span>Goed</span></button>
                                    <button *ngIf="data.status == 'GOOD'"
                                        class="btn btn-warning"><span>Voldoende</span></button>
                                    <button *ngIf="data.status == 'WRONG'"
                                        class="btn btn-danger"><span>Onvoldoende</span></button>
                                </div>
                                <hr>
                                <div class="teacherChat" *ngIf="data['feedbackItems'] && data['feedbackItems'].length > 0">
                                    <div *ngFor="let feedback of data['feedbackItems']">
                                        <h6>
                                            {{feedback.name}} 
                                            <small>{{formatDutchDate(feedback.createdAt)}}</small> 
                                            <span *ngIf="!feedback.readAt" class="unread-feedback">Nieuw</span>
                                        </h6>
                                        <p>{{feedback.message}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>